import { loadStoredManageContextRaw } from "./manageContext";

export function hasKioskTimesheetSearchParams(searchString) {
  const params = new URLSearchParams(searchString || "");
  if (params.get("qrToken")) return true;
  if (params.get("timesheetId")) return true;
  return !!(params.get("clientId") && params.get("from") && params.get("client"));
}

export function getTodayDateOnly() {
  return new Date().toISOString().slice(0, 10);
}

/** Same kiosk triple as URL check: clientId + from date + client label (mirrors hasKioskTimesheetSearchParams). */
export function hasDeviceKioskContextFields(ctx) {
  if (!ctx || typeof ctx !== "object") return false;
  const clientId = String(ctx.clientId ?? "").trim();
  if (!clientId) return false;
  const from = String(ctx.startDate ?? ctx.shiftDate ?? "").trim();
  if (!from) return false;
  const client = String(ctx.clientName ?? "").trim();
  if (!client) return false;
  return true;
}

/**
 * Builds /checkin search params from persisted assign context (same shape as DeviceAssign).
 * @param {Record<string, unknown>} ctx - raw or merged manage context
 * @returns {URLSearchParams | null}
 */
export function buildCheckinSearchParamsFromDeviceContext(ctx) {
  if (!hasDeviceKioskContextFields(ctx)) return null;
  const from = String(ctx.startDate ?? ctx.shiftDate ?? "").trim();
  const params = new URLSearchParams({
    clientId: String(ctx.clientId).trim(),
    from,
    client: String(ctx.clientName).trim(),
  });
  const loc = String(ctx.locationName ?? "").trim();
  if (loc) {
    params.set("location", loc);
  }
  return params;
}

/** Persisted manageContext from localStorage if it satisfies kiosk triple. */
export function resolveKioskSearchFromStorage() {
  const raw = loadStoredManageContextRaw();
  if (!hasDeviceKioskContextFields(raw)) return null;
  return buildCheckinSearchParamsFromDeviceContext(raw);
}
